<div class="row">
  <div class="col-3">
    <app-number-scroll [nameChamp]="'miseEnCirculation'" [labelChamp]="'Jours'" min="1" max="31"
                       [debutcount]="this.defaultDay" (numeroChange)="onDayChange($event)"></app-number-scroll>
  </div>
  <div class="col-3">
    <app-number-scroll [nameChamp]="'miseEnCirculation'" [labelChamp]="'Mois'" min="1" max="12"
                       [debutcount]="this.defaultMonth" (numeroChange)="onMonthChange($event)"></app-number-scroll>
  </div>
  <div class="col-6">
    <app-number-scroll [nameChamp]="'miseEnCirculation'" [labelChamp]="'Année'" [min]="this.minYear" [max]="this.maxYear"
                       [debutcount]="this.defaultYear" (numeroChange)="onYearChange($event)"></app-number-scroll>
  </div>
</div>
